import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';

/**
 * Renders children only if the current user has at least one of the allowed roles.
 */
const RequireRoles = (props) => {
  const { children, roles: allowedRoles } = props;
  const { user } = useAuth();
  const userRoles = user?.roles || [];
  const hasAccess = allowedRoles.some((role) => userRoles.includes(role));

  if (!hasAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

RequireRoles.propTypes = {
  children: PropTypes.node.isRequired,
  roles: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
};

export default RequireRoles;
